export const FETCH_COLORS_REQUEST = 'FETCH_COLORS_REQUEST';
export const FETCH_COLORS_SUCCESS = 'FETCH_COLORS_SUCCESS';
export const FETCH_COLORS_FAILURE = 'FETCH_COLORS_FAILURE';

export const CREATE_COLOR = 'CREATE_COLOR';
export const UPDATE_COLOR = 'UPDATE_COLOR';
export const DELETE_COLOR = 'DELETE_COLOR';

// Loading states for CRUD operations
export const CREATE_COLOR_REQUEST = 'CREATE_COLOR_REQUEST';
export const CREATE_COLOR_SUCCESS = 'CREATE_COLOR_SUCCESS';
export const CREATE_COLOR_FAILURE = 'CREATE_COLOR_FAILURE';

export const UPDATE_COLOR_REQUEST = 'UPDATE_COLOR_REQUEST';
export const UPDATE_COLOR_SUCCESS = 'UPDATE_COLOR_SUCCESS';
export const UPDATE_COLOR_FAILURE = 'UPDATE_COLOR_FAILURE';

export const DELETE_COLOR_REQUEST = 'DELETE_COLOR_REQUEST';
export const DELETE_COLOR_SUCCESS = 'DELETE_COLOR_SUCCESS';
export const DELETE_COLOR_FAILURE = 'DELETE_COLOR_FAILURE';
